export const layouts = ["tile", "sidebar", "classic"];

const getRandomLayout = () =>
  layouts[Math.floor(Math.random() * layouts.length)];

export default getRandomLayout;
